import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';
import '../portal/application.scss';
import Vue from 'vue';
import { InitializationHelpers } from '../portal/portalHelpers';
import { initFormRules } from '../portal/formRulesBinding';
import { initFormValidation } from '../portal/formValidationBinding';
import { initFormRecaptcha } from '../portal/formRecaptcha';
import { initFormErrorModal } from '../portal/formErrorModal';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import { domPurifyConfig } from '../shared/helpers/HTMLSanitizer';
import { directive as onClickaway } from 'vue-clickaway';
import FluentIcon from 'shared/components/FluentIcon/DashboardIcon';
import WootButton from 'dashboard/components/ui/WootButton.vue';

Vue.use(VueDOMPurifyHTML, domPurifyConfig);
Vue.directive('on-clickaway', onClickaway);
Vue.component('fluent-icon', FluentIcon);
Vue.component('woot-button', WootButton);

Rails.start();
Turbolinks.start();

const onPortalLoad = () => {
  InitializationHelpers.onLoad();
  initFormRules();
  initFormValidation();
  initFormRecaptcha();
  initFormErrorModal();
};

document.addEventListener('turbolinks:load', onPortalLoad);
